import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

export function exportDataGridToCsv({
  apiRef,
  fileName,
  dateFields = [],
  rowsData = [],
}) {
  if (!apiRef?.current && !rowsData.length) return

  const excludedFields = ['action', '__detail_panel_toggle__', '__check__'] // exclude action/checkbox

  // Get visible columns or fallback to keys from data
  const visibleColumns = apiRef?.current
    ? apiRef.current
        .getVisibleColumns()
        .filter((col) => !excludedFields.includes(col.field))
    : Object.keys(rowsData[0] || {}).map((field) => ({
        field,
        headerName: field,
      }))

  const visibleFields = visibleColumns.map((col) => col.field)

  const headerMap = visibleColumns.reduce((acc, col) => {
    acc[col.field] = col.headerName || col.field
    return acc
  }, {})

  const rows = rowsData.length
    ? rowsData
    : Array.from(apiRef.current.getRowModels().values())

  const csvData = rows.map((row) => {
    const formattedRow = {}

    visibleFields.forEach((field) => {
      let value = row[field]

      // Special handling for date fields
      if (dateFields.includes(field) && value) {
        const parsed = dayjs(value)
        if (parsed.isValid()) {
          // Formula trick to keep DD-MM-YYYY in Excel
          value = `="${parsed.format('DD-MM-YYYY')}"`
        } else {
          value = `${value}` // Force as text if invalid date
        }
      }

      formattedRow[field] = value
    })

    return formattedRow
  })

  const escapeCSV = (val = '') => {
    return `"${String(val).replace(/"/g, '""')}"`
  }

  const csvHeaders = visibleFields.map((field) =>
    escapeCSV(headerMap[field] || field)
  )

  const csvContent = [csvHeaders.join(',')]
    .concat(
      csvData.map((row) =>
        visibleFields.map((f) => escapeCSV(row[f])).join(',')
      )
    )
    .join('\n')

  const BOM = '\uFEFF'
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.setAttribute('download', `${fileName || 'export'}.csv`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
